import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { map, Observable } from 'rxjs';
import { DependencyNodeDto } from '../data-models/dependency-tree.dto.model';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class DependencyApiService {
  instanceId: string;
  defaultHttpOptions = {
    headers: new HttpHeaders({
      'Content-Type': 'application/json',
    }),
  };

  constructor(
    private http: HttpClient,
  ) { }

  getDependencyTree(rootId: string, rootVersion: string): Observable<DependencyNodeDto> {
    return this.http.get<DependencyNodeDto>(`${environment.apiHost + environment.apiUrl}/artifacts/dependency-graph/${rootId}:${rootVersion}`);
  }
}
